import React, { ReactElement } from "react";

import CheckPermissions from "../../CheckPermissions";

import { COMPONENTS } from "@utils/Constants";

export const RankOverridesLazy = async (): Promise<{
  Component: () => React.ReactElement;
}> => {
  const { default: RankOverrides } = await import("@workflows/bundles/overrides/rank-overrides");
  const WrappedRules = (): ReactElement => (
    <CheckPermissions name={COMPONENTS.BUNDLES_RANK_OVERRIDES}>
      <RankOverrides />
    </CheckPermissions>
  );
  return { Component: WrappedRules };
};
